<template>
  <div
    class="drop"
    :class="{ drop_showing }"
    v-click-outside="hide"
    :style="getPosition()"
  >
    <a
      v-for="option of overflow_options"
      :key="option.label"
      @click.stop="handleClick(option)"
      :class="option.class"
    >
      {{ option.label }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'OverflowDrop',
  computed: {
    overflow_options() {
      return this.$store.getters.overflow_options;
    },
    overflow_position() {
      return this.$store.getters.overflow_position;
    },
    overflow_item_id() {
      return this.$store.getters.overflow_item_id;
    },
    drop_showing() {
      return this.$store.getters.overflow_drop_showing;
    },
  },
  methods: {
    toggle() {
      this.$store.dispatch('setOverflowDropShowing', !this.drop_showing);
    },
    hide() {
      this.$store.dispatch('setOverflowDropShowing', false);
    },
    handleClick(option) {
      this.hide();
      option.handler(this.overflow_item_id);
    },
    getPosition() {
      const top = this.overflow_position.top + 'px';
      const offset = document.querySelector('#main-view').offsetLeft;
      const left = this.drop_showing
        ? this.overflow_position.left - offset + 'px'
        : '-99999px';

      return { top, left };
    },
  },
};
</script>
<!--TODO - Add Scoped-->
<style lang="scss">
//@import '../styles/_styles.scss';

.drop {
  position: absolute;
  opacity: 0;
  width: 200px;
  height: auto;
  background: white;
  border-radius: 4px;
  transition: margin 0.5s, opacity 0.5s;
  z-index: 5000;
  box-shadow: 0 0 14px 2px rgba(41, 42, 44, 0.09);
  border: 1px solid #e2e5ec !important;
  display: flex;
  flex-direction: column;
  margin-top: 0;

  a {
    width: 100%;
    padding: 12px 20px 12px 50px;
    color: #26292f;
    font-size: 13px;
    font-weight: 400;
    background-repeat: no-repeat;
    background-size: 20px 20px;
    background-position: center left 20px;
    transition: background-color 0.3s;
    cursor: pointer;

    &.delete {
      background-image: url(~@/assets/icons/trash_only.svg);
    }

    &.edit {
      background-image: url(~@/assets/icons/edit.svg);
    }

    &:hover {
      background-color: #eceef1;
    }

    &:first-child {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    &:last-child {
      border-top: 1px solid #e2e5ec;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  &.drop_showing {
    opacity: 1;
    margin-top: 30px;
  }
}
</style>
